module.exports = __webpack_public_path__ + "img/ctrl-rx-theta-dagger-stub-+i.df8d13f4.svg";